const QUILL_EMPTY_CONTENT_PATTERN = /^<p>(?:<br\s*\/?>|\s|&nbsp;)*<\/p>$/i;

const normalizeLegacyQuillLists = (root: HTMLElement, doc: Document) => {
  const orderedLists = Array.from(root.querySelectorAll('ol'));

  orderedLists.forEach((orderedList) => {
    const listItems = Array.from(orderedList.children).filter(
      (child): child is HTMLLIElement => child.tagName === 'LI'
    );

    if (
      listItems.length === 0 ||
      !listItems.some((item) => item.hasAttribute('data-list'))
    ) {
      return;
    }

    const fragment = doc.createDocumentFragment();
    let currentListTag: 'ol' | 'ul' | null = null;
    let currentList: HTMLOListElement | HTMLUListElement | null = null;

    listItems.forEach((item) => {
      const dataList = item.getAttribute('data-list');
      const nextListTag: 'ol' | 'ul' =
        dataList === 'bullet' ||
        dataList === 'checked' ||
        dataList === 'unchecked'
          ? 'ul'
          : 'ol';

      if (!currentList || currentListTag !== nextListTag) {
        currentList = doc.createElement(nextListTag) as
          HTMLOListElement | HTMLUListElement;
        fragment.appendChild(currentList);
        currentListTag = nextListTag;
      }

      item.removeAttribute('data-list');
      currentList.appendChild(item);
    });

    orderedList.replaceWith(fragment);
  });
};

export const normalizeQuillHtml = (html: string) => {
  const raw = (html || '').trim();
  if (!raw || QUILL_EMPTY_CONTENT_PATTERN.test(raw)) {
    return '';
  }

  if (typeof DOMParser === 'undefined') {
    return raw;
  }

  const doc = new DOMParser().parseFromString(raw, 'text/html');
  const { body } = doc;

  body.querySelectorAll('span.ql-ui').forEach((node) => node.remove());
  normalizeLegacyQuillLists(body, doc);

  // Quill replaces all spaces with &nbsp; in getSemanticHTML(), which
  // prevents the browser from wrapping text at word boundaries.  Convert
  // non-breaking spaces back to regular spaces so words stay intact.
  const walker = doc.createTreeWalker(body, NodeFilter.SHOW_TEXT);
  let textNode: Text | null;
  while ((textNode = walker.nextNode() as Text | null)) {
    if (textNode.nodeValue) {
      textNode.nodeValue = textNode.nodeValue.replace(/\u00a0/g, ' ');
    }
  }

  const normalized = body.innerHTML.trim();
  if (!normalized || QUILL_EMPTY_CONTENT_PATTERN.test(normalized)) {
    return '';
  }

  return normalized;
};

export const isRichTextMeaningfullyEmpty = (html: string) => {
  const text = (html || '')
    .replace(/<(.|\n)*?>/g, '')
    .replace(/&nbsp;/g, ' ')
    .trim();
  return text.length === 0;
};
